const palette = {
  mode: "light",
  "grey[100]": "#f5f5f5",
  primary: {
    light: "#d8f3dc",
    main: "#40916c",
    dark: "#081c15",
  },
  secondary: {
    light: "#ffffff",
    main: "#d8f3dc",
    dark: "#f8f8fb",
  },
  error: {
    light: "#ef5350",
    main: "#d32f2f",
    dark: "#c62828",
  },
  warning: {
    light: "#f18f1b",
    main: "#f18f1b",
    dark: "#e65100",
  },
  info: {
    light: "#03a9f4",
    main: "#0288d1",
    dark: "#0288d1",
  },
  Success: {
    light: "#4caf50",
    main: "#2e7d32",
    dark: "#1b5e20",
  },
};

export default palette;
